export const COURSE_UPDATED = 'Course details updated.';
export const COURSES_DELETED = 'Courses deleted.';
export const COURSE_CREATED = 'Course created.';
export const MEMBERBODY_REQUIRED = 'Please select an Event Organizer first.';
export const COURSE_DUPLICATED = 'Course duplicated successfully.';
export const COURSE_DUPLICATE_ERROR = 'Unable to duplicate course.';
